import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EditRoutingModule } from './edit-routing.module';
import { EditComponent } from './pages/edit/edit.component';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared/shared.module';
import { NgxsModule } from '@ngxs/store';
import { EditState } from './state/edit.state';
import { EditDocumentContextComponent } from './components/edit-document-context/edit-document-context.component';
import { EditLabelContextComponent } from './components/edit-label-context/edit-label-context.component';
import { EngineModule } from '../engine/engine.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoryModule } from '../story/story.module';
import { LabelWidgetComponent } from './components/edit-label-context/label-widget/label-widget.component';
import { ChapterBrowserComponent } from './components/chapter-browser/chapter-browser.component';
import { ChapterCardComponent } from './components/chapter-card/chapter-card.component';
import { EditPaintContextComponent } from './components/edit-paint-context/edit-paint-context.component';
import { EditPaintState } from './state/paint/edit.paint.state';
import { PaintWidgetComponent } from './components/edit-paint-context/paint-widget/paint-widget.component';
import { PaintPresetsComponent } from './components/edit-paint-context/paint-presets/paint-presets.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { CheckedNodesComponent } from './components/checked-nodes/checked-nodes.component';
import { NavigationContextComponent } from './components/navigation-context/navigation-context.component';
import { CameraPositionComponent } from './components/camera-position/camera-position.component';
import { PublishDialogComponent } from '../publish/components/publish-dialog/publish-dialog.component';
import { EditChapterPaginationComponent } from './components/edit-chapter-pagination/edit-chapter-pagination.component';
import { ChapterActionsComponent } from './components/chapter-actions/chapter-actions.component';
import { ContentDialogComponent } from './components/content-dialog/content-dialog.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PaintPaletteSwatchComponent } from './components/edit-paint-context/paint-palette-swatch/paint-palette-swatch.component';
import { DialogModule } from '../dialogs/dialog.module';
import { EditExitComponent } from './components/edit-exit/edit-exit.component';
import { ConversionAlertComponent } from './components/edit-label-context/conversion-alert/conversion-alert.component';
import { ModulesModule } from '../modules/modules.module';

@NgModule({
  imports: [
    NgxsModule.forFeature([
      EditState,
      EditPaintState
    ]),

    CommonModule,
    ColorPickerModule,
    DialogModule,
    EditRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    EngineModule,
    MaterialModule,
    SharedModule,
    StoryModule,
    FontAwesomeModule,
    ModulesModule
  ],
  declarations: [
    EditComponent,
    EditDocumentContextComponent,
    EditLabelContextComponent,
    LabelWidgetComponent,
    EditChapterPaginationComponent,
    ChapterBrowserComponent,
    ChapterCardComponent,
    EditPaintContextComponent,
    PaintPaletteSwatchComponent,
    PaintWidgetComponent,
    PaintPresetsComponent,
    CheckedNodesComponent,
    NavigationContextComponent,
    CameraPositionComponent,
    ChapterActionsComponent,
    ContentDialogComponent,
    EditExitComponent,
    ConversionAlertComponent
  ],
  entryComponents: [
    PaintPaletteSwatchComponent,
    PublishDialogComponent,
    ContentDialogComponent
  ],
  exports: [EditRoutingModule]
})
export class EditModule { }
